import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, RunIdSchema } from "../primitives/ids.js";
import { EnreinArtifactUriSchema } from "./artifact-uri.js";
/** Latest passing artifact pointer for a project. */
export const ArtifactIndexV1Schema = z
    .object({
    schemaVersion: z.literal("artifact-index.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    latestPassingRunId: RunIdSchema,
    latestPassingArtifactUri: EnreinArtifactUriSchema,
    artifactSetHash: z.string().min(1),
    businessGraphRevisionId: z.string().min(1),
    updatedAt: z.string().datetime(),
})
    .strict();
//# sourceMappingURL=artifact-index.js.map